export const SET_EXTENSION = 'SET_EXTENSION'
export const RESET_EXTENSION = 'RESET_EXTENSION'
